<form [formGroup]="resetPasswordForm" (ngSubmit)="submitForm()">
  <div class="md:flex md:gap-4 md:mb-16">
    <div class="mb-8 md:mb-0 w-full">
      <p-float-label>
        <p-password [id]="id + 'senha'" formControlName="password" promptLabel="Escolha uma senha"
          weakLabel="Muito simples" mediumLabel="Complexidade média" strongLabel="Senha forte" [toggleMask]="true"
          [pTooltip]="formWatched['children']['password']() | formFieldFeedback" tooltipEvent="hover"
          tooltipPosition="right" />
        <label [for]="id + 'senha'">Senha</label>
      </p-float-label>
    </div>
    <div class="mb-16 md:mb-0 w-full">
      <p-float-label>
        <p-password [id]="id + 'confirmacao'" formControlName="confirmPassword" promptLabel="Escolha uma senha"
          weakLabel="Muito simples" mediumLabel="Complexidade média" strongLabel="Senha forte" [toggleMask]="true"
          [pTooltip]="formWatched['children']['confirmPassword']() | formFieldFeedback" tooltipEvent="hover"
          tooltipPosition="right" />
        <label [for]="id + 'confirmacao'">Confirme a senha</label>
      </p-float-label>
    </div>
  </div>
  @if(formWatched["group"]().errors){
  <div class="border-red-500 border-2 bg-red-100 text-red-500 p-2 mb-8 rounded-md">
    {{ formWatched["group"]() | formFieldFeedback }}
  </div>
  }
  <p-button styleClass="w-full mb-4 font-semibold" [loading]="isLoading()" [disabled]="isLoading() || !enabled()"
    type="submit" label="Alterar senha" />
</form>